// adapted from https://github.com/on-the-edge-cloud/react-circle-flags/blob/master/src/index.js

import { DetailedHTMLProps, ImgHTMLAttributes } from 'react'

import { territories } from './territories'

const CDN_URL = 'https://react-circle-flags.pages.dev/'
const FILE_SUFFIX = 'svg'

const UNKNOWN_FLAG = 'xx'
const DEFAULT_HEIGHT = 100

interface CircleFlagProps
  extends DetailedHTMLProps<ImgHTMLAttributes<HTMLImageElement>, HTMLImageElement> {
  /**
   * Country code of flag.
   */
  countryCode: string
}

const getSvgProps = (code: string, otherProps: React.ImgHTMLAttributes<HTMLImageElement>) => ({
  ...otherProps,
  title: otherProps.title || code,
  height: otherProps.height || DEFAULT_HEIGHT,
  src: `${CDN_URL}${code}.${FILE_SUFFIX}`
})

const parseCountryCode = (countryCode: string) =>
  territories[countryCode]
    ? countryCode
    : countryCode.includes('us')
      ? 'us'
      : countryCode.includes('ca')
        ? 'ca'
        : UNKNOWN_FLAG

export const CircleFlag = ({ countryCode, ...otherProps }: CircleFlagProps) => (
  <img
    data-testid="circle-country-flag"
    {...getSvgProps(parseCountryCode(countryCode).toLowerCase(), otherProps)}
  />
)
